// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1TmjZ","overflowing":"ReadFullNote_overflowing__3JjCJ"};